var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("保安列表")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("保安列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "用户姓名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入姓名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "邀请人姓名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入邀请人姓名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.inviteName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "inviteName", $$v)
                                    },
                                    expression: "ruleForm.inviteName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "用户手机号" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入手机号",
                                  },
                                  model: {
                                    value: _vm.ruleForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "phone", $$v)
                                    },
                                    expression: "ruleForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "账号状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择账号状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "拉黑", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "正常", value: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "待审核", value: "2" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "审核失败", value: "3" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "资料待完善",
                                        value: "4",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已注销", value: "5" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "保安服务状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: {
                                      placeholder: "请选择保安服务状态",
                                    },
                                    model: {
                                      value: _vm.ruleForm.isJob,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "isJob", $$v)
                                      },
                                      expression: "ruleForm.isJob",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "可接单", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "服务中", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "服务省", prop: "type1" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.cityChange },
                                    model: {
                                      value: _vm.ruleForm.type1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "type1", $$v)
                                      },
                                      expression: "ruleForm.type1",
                                    },
                                  },
                                  _vm._l(_vm.city, function (item, index) {
                                    return _c("el-option", {
                                      key: item.adcode,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _vm.ruleForm.type1 != "100000"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "服务城市",
                                      prop: "select",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { "margin-right": "auto" },
                                        attrs: { placeholder: "请选择" },
                                        on: { change: _vm.cityChange1 },
                                        model: {
                                          value: _vm.ruleForm.select,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "select",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.select",
                                        },
                                      },
                                      _vm._l(_vm.city1, function (item, index) {
                                        return _c("el-option", {
                                          key: item.adcode,
                                          attrs: {
                                            label: item.name,
                                            value: item.adcode,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "保安类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择保安类型" },
                                    model: {
                                      value: _vm.ruleForm.accountType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "accountType",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.accountType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "企业", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "企业员工", value: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "临勤", value: "2" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList("new")
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "姓名", align: "center", width: "130" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.accountType == 0
                                  ? scope.row.companyName
                                  : scope.row.cardName
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "phone",
                    label: "手机号",
                    align: "center",
                    width: "120px",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "xwbankStatus",
                    label: "是否开户",
                    align: "center",
                    width: "120px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.xwbankStatus == 0
                                  ? "未开户"
                                  : scope.row.xwbankStatus == 1
                                  ? "已开户"
                                  : scope.row.xwbankStatus == 2
                                  ? "开户失败"
                                  : "审核中"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "jobsTotal",
                    label: "完成任务次数",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "职业", align: "center", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            { attrs: { trigger: "hover", placement: "top" } },
                            [
                              _vm._l(
                                scope.row.bodyguardCerts,
                                function (item, index) {
                                  return _c("span", [
                                    _vm._v(
                                      _vm._s(item.careerTypeName) +
                                        "-" +
                                        _vm._s(item.levelTypeName)
                                    ),
                                    scope.row.bodyguardCerts.length > 1
                                      ? _c("span", [_vm._v("/")])
                                      : _vm._e(),
                                  ])
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "name-wrapper",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  scope.row.bodyguardCerts
                                    ? _c("div", { staticClass: "omit" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              scope.row.bodyguardCerts &&
                                                scope.row.bodyguardCerts
                                                  .length > 1
                                                ? "多认证"
                                                : "单认证"
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "注册时间",
                    align: "center",
                    width: "160px",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginCity",
                    label: "地区",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "最近登录地区",
                    align: "center",
                    width: "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.lastLoginAddress)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "保安类型", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.accountType == 0
                                  ? "企业"
                                  : scope.row.accountType == 1
                                  ? "企业员工"
                                  : "临勤"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "营业类型", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.businessType == 0 ? "第三方" : "直营"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "微信认证", align: "center", width: "100px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.wxVerifiedStatus == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("未认证"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.wxVerifiedStatus == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已认证"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "身份认证", align: "center", width: "100px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.cadeVerifyStatus == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("未通过"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.cadeVerifyStatus == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("已通过"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "服务状态", align: "center", width: "120px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.isJob == 0 && scope.row.status != 1
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("不可接单"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.isJob == 0 && scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("可接单"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.isJob == 1
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("服务中"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "jobName",
                    label: "任务名称",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "customName",
                    label: "发布人名",
                    align: "center",
                    width: "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "jobEnd",
                    label: "服务完成时间",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "账号状态", align: "center", width: "120px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("拉黑"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("正常"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 2
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("待审核"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 4
                            ? _c("span", { staticClass: "blueColor" }, [
                                _vm._v("资料待完善"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 5
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("已注销"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 3
                            ? _c(
                                "el-popover",
                                {
                                  attrs: { trigger: "hover", placement: "top" },
                                },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(scope.row.rejectReason)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "name-wrapper",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _c("span", { staticClass: "redColor" }, [
                                        _vm._v("审核失败"),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "pidName",
                    label: "邀请人",
                    align: "center",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.inviteName))]),
                          scope.row.invitePhone && scope.row.invitePhone != ""
                            ? _c("span", [
                                _vm._v(
                                  "(" + _vm._s(scope.row.invitePhone) + ")"
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginAddress",
                    label: "最近登录地址",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginProvince",
                    label: "最近登录省份",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginCity",
                    label: "最近登录城市",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginArea",
                    label: "最近登录地区",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastLoginTime",
                    label: "最近登录时间",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "手机品牌", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.lastPhoneBrand
                                  ? scope.row.lastPhoneBrand
                                  : "null"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "手机型号", align: "center", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.lastPhoneModel
                                  ? scope.row.lastPhoneModel
                                  : "null"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "手机系统号", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.lastPhoneSystemVersion
                                  ? scope.row.lastPhoneSystemVersion
                                  : "null"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "当前App版本号", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.versionNo
                                  ? scope.row.versionNo
                                  : "null"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    fixed: "right",
                    width: "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            scope.row.isExamine == 1 && scope.row.isLogoff == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                审核\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn greenColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                恢复\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                拉黑\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.isLogoff == 0 &&
                            (scope.row.status == 1 || scope.row.status == 3)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelexamine(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                审核撤销\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _vm._v(" "),
                            scope.row.accountType == 0 &&
                            scope.row.isLogoff == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.dowLoad(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                下载二维码\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("TableScrollSlider", {
              attrs: { "table-ref": _vm.$refs.scrollTable },
            }),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核信息",
            visible: _vm.dialogVisible,
            width: "80%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "infoBox" }, [
            _vm.detail.accountType == 0
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "75%" } }, [
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.detail.accountType == 0
                                  ? "企业"
                                  : _vm.detail.accountType == 1
                                  ? "企业员工"
                                  : _vm.detail.accountType == 2
                                  ? "临勤"
                                  : "消防保安"
                              ) +
                              "信息\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                          },
                          [
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                注册类型：" +
                                  _vm._s(
                                    _vm.detail.accountType == 0
                                      ? "企业"
                                      : _vm.detail.accountType == 1
                                      ? "企业员工"
                                      : _vm.detail.accountType == 2
                                      ? "临勤"
                                      : "消防保安"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "公司名称：" + _vm._s(_vm.detail.companyName)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                统一社会信用代码：" +
                                  _vm._s(_vm.detail.licenseNo) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "flex-wrap": "wrap",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                监管单位：\n                "
                                ),
                                _vm._l(
                                  _vm.selectedRows,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "2px 4px",
                                          "box-sizing": "border-box",
                                          "border-radius": "6px",
                                          background:
                                            "RGBA(134, 144, 156, 0.5)",
                                          display: "flex",
                                          "margin-right": "6px",
                                        },
                                      },
                                      [
                                        _c("div", [_vm._v(_vm._s(item.name))]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "8px",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.close(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    ×\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "right",
                                      width: "400",
                                      trigger: "click",
                                    },
                                    on: { show: _vm.showTab },
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content":
                                                "space-between",
                                              margin: "10px 0",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "50",
                                                clearable: "",
                                                placeholder:
                                                  "请输入监管单位名称搜索",
                                              },
                                              model: {
                                                value: _vm.torgValue,
                                                callback: function ($$v) {
                                                  _vm.torgValue = $$v
                                                },
                                                expression: "torgValue",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "btn",
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getorgList("new")
                                                  },
                                                },
                                              },
                                              [_vm._v("查询")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-table",
                                          {
                                            ref: "multipleTable",
                                            attrs: {
                                              data: _vm.orgList,
                                              "tooltip-effect": "dark",
                                              "row-key": "id",
                                            },
                                            on: {
                                              select: _vm.handleSelect,
                                              "select-all": _vm.handleSelectAll,
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                type: "selection",
                                                width: "55",
                                                "reserve-selection": true,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                property: "id",
                                                label: "ID",
                                                width: "170",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                property: "name",
                                                label: "监管单位",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-pagination", {
                                          attrs: {
                                            "current-page": _vm.currentPage1,
                                            "page-size": 10,
                                            small: "",
                                            layout: "total,prev, pager, next",
                                            total: _vm.orgTotal,
                                            width: "80%",
                                          },
                                          on: {
                                            "current-change":
                                              _vm.handleCurrentChange1,
                                            "update:currentPage": function (
                                              $event
                                            ) {
                                              _vm.currentPage1 = $event
                                            },
                                            "update:current-page": function (
                                              $event
                                            ) {
                                              _vm.currentPage1 = $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          color: "blue",
                                          "margin-left": "10px",
                                        },
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    选择监管单位\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "10px",
                                  "margin-left": "10px",
                                },
                              },
                              [
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                  注册地址：" +
                                      _vm._s(_vm.detail.registerAddress) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                  注册资金：" +
                                      _vm._s(_vm.detail.registeredCapital) +
                                      "万\n                "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "infoItem",
                                staticStyle: { "margin-top": "10px" },
                              },
                              [
                                _vm._v(
                                  "\n                经营范围：" +
                                    _vm._s(_vm.detail.businessScope) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "infoItem",
                            staticStyle: {
                              width: "100px",
                              "margin-right": "20px",
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm.detail.businessLicense,
                                alt: "",
                                "preview-src-list": [
                                  _vm.detail.businessLicense,
                                ],
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "75%" } }, [
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v("保安服务许可证信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                          },
                          [
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                许可证编号：" +
                                  _vm._s(_vm.detail.serviceLicenseNumber) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "服务范围：" + _vm._s(_vm.detail.gscScope)
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "infoItem",
                            staticStyle: {
                              width: "100px",
                              "margin-right": "20px",
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm.detail.guardLicenseUrl,
                                alt: "",
                                "preview-src-list": [
                                  _vm.detail.guardLicenseUrl,
                                ],
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _vm.detail.legalPersonResp
                        ? _c("div", { staticStyle: { width: "75%" } }, [
                            _c("div", { staticClass: "modelTitle" }, [
                              _vm._v("法人信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-wrap": "wrap",
                                },
                              },
                              [
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                姓名：" +
                                      _vm._s(_vm.detail.legalPersonResp.name) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                民族：" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp.nationality
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                性别：" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp.sex == 1
                                          ? "男"
                                          : "女"
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                出生年月：" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp.birthday
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                证件有效期：" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp
                                          .cardValidityStart
                                      ) +
                                      "-" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp
                                          .cardValidityEnd
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                签发机关：" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp
                                          .issuingAuthority
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "infoItem" }, [
                                  _vm._v(
                                    "\n                地址：" +
                                      _vm._s(
                                        _vm.detail.legalPersonResp
                                          .currentAddress
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.detail.legalPersonResp
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "infoItem",
                                staticStyle: {
                                  width: "200px",
                                  "margin-right": "20px",
                                  display: "flex",
                                },
                              },
                              [
                                _c("el-image", {
                                  attrs: {
                                    src: _vm.detail.legalPersonResp
                                      .cardPhotoFront,
                                    alt: "",
                                    "preview-src-list": [
                                      _vm.detail.legalPersonResp.cardPhotoFront,
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-image", {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    src: _vm.detail.legalPersonResp
                                      .cardPhotoBack,
                                    alt: "",
                                    "preview-src-list": [
                                      _vm.detail.legalPersonResp.cardPhotoBack,
                                    ],
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.accountType != 0
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "75%" } }, [
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.detail.accountType == 0
                                  ? "企业"
                                  : _vm.detail.accountType == 1
                                  ? "企业员工"
                                  : _vm.detail.accountType == 2
                                  ? "临勤"
                                  : "消防保安"
                              ) +
                              "信息\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                          },
                          [
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                注册类型：" +
                                  _vm._s(
                                    _vm.detail.accountType == 0
                                      ? "企业"
                                      : _vm.detail.accountType == 1
                                      ? "企业员工"
                                      : _vm.detail.accountType == 2
                                      ? "临勤"
                                      : "消防保安"
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v("姓名：" + _vm._s(_vm.detail.cardName)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                性别：" +
                                  _vm._s(_vm.detail.sex == 1 ? "男" : "女") +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "身份证号：" + _vm._s(_vm.detail.cardCode)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v("手机号：" + _vm._s(_vm.detail.phone)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "出生年月：" + _vm._s(_vm.detail.birthday)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v("身高(厘米)：" + _vm._s(_vm.detail.high)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "体重(公斤)：" + _vm._s(_vm.detail.weight)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                证件有效期：" +
                                  _vm._s(_vm.detail.cardValidity) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                签发机关：" +
                                  _vm._s(_vm.detail.issuingAuthority) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v("地址：" + _vm._s(_vm.detail.address)),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "infoItem",
                            staticStyle: {
                              width: "150px",
                              "margin-right": "20px",
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm.detail.cardFrontUrl,
                                alt: "",
                                "preview-src-list": [_vm.detail.cardFrontUrl],
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "infoItem",
                            staticStyle: {
                              width: "150px",
                              "margin-right": "20px",
                            },
                          },
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm.detail.cardBackUrl,
                                alt: "",
                                "preview-src-list": [_vm.detail.cardBackUrl],
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "75%" } }, [
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v("保安证信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                          },
                          [
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                保安证件号：" +
                                  _vm._s(
                                    _vm.detail.bodyguardCerts &&
                                      _vm.detail.bodyguardCerts[0]
                                      ? _vm.detail.bodyguardCerts[0].certNumber
                                      : ""
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { display: "flex", "flex-wrap": "wrap" },
                        },
                        _vm._l(_vm.imgList, function (item) {
                          return _c(
                            "div",
                            {
                              staticClass: "infoItem",
                              staticStyle: { width: "100px", height: "150px" },
                            },
                            [
                              _c("el-image", {
                                staticStyle: {
                                  width: "100px",
                                  height: "150px",
                                },
                                attrs: {
                                  src: item.certFrontUrl,
                                  alt: "",
                                  "preview-src-list": [item.certFrontUrl],
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "modelTitle" }, [_vm._v("审核操作")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "infoItem", staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { "margin-right": "auto" },
                      attrs: { placeholder: "请选择审核状态" },
                      model: {
                        value: _vm.state,
                        callback: function ($$v) {
                          _vm.state = $$v
                        },
                        expression: "state",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "通过", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "拒绝", value: "0" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.detail.accountType != 0 && _vm.state == 1
                ? _c(
                    "div",
                    { staticClass: "infoItem", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-right": "auto" },
                          attrs: { placeholder: "请选择保安等级" },
                          model: {
                            value: _vm.level,
                            callback: function ($$v) {
                              _vm.level = $$v
                            },
                            expression: "level",
                          },
                        },
                        _vm._l(_vm.tableData1, function (i, i1) {
                          return _c("el-option", {
                            key: i1,
                            attrs: { label: i.propDesc, value: i.propValue },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.state == "0"
                ? _c(
                    "div",
                    { staticClass: "infoItem" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入拒绝原因",
                        },
                        model: {
                          value: _vm.textarea,
                          callback: function ($$v) {
                            _vm.textarea = $$v
                          },
                          expression: "textarea",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeModel } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.shenhe()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "保安公司邀请临勤二维码",
            visible: _vm.dialogVisible1,
            width: "1000px",
            "before-close": _vm.handleClose1,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible1 = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("QRCodeOnImage", {
                attrs: { qrText: _vm.url, footerText: _vm.textUnderQr },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }